import {
    ACTIVATION_BRIEF_STATUS_IN_REVIEW,
    ACTIVATION_BRIEF_STATUS_NONE,
    ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL,
    ACTIVATION_BRIEF_STATUS_ARCHIVED,
    ACTIVATION_BRIEF_STATUS_LABELS
} from '../../../../constants/activation-brief';
import {get, flatten} from 'lodash';
import moment from 'moment';

export default {
    props: {
        isPreview: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            briefRecomputeSubmissionDatesAt: null,
        };
    },
    computed: {
        //@TODO: rename to isActive end inverse the logic
        isBriefAccepted() {
            return !this.hasStatus([
                ACTIVATION_BRIEF_STATUS_NONE,
                ACTIVATION_BRIEF_STATUS_IN_REVIEW,
                ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL,
            ]);
        },
        isBriefCompleted() {
            return get(this, 'brief.is_submitted', false);
        },
        isActivationArchived() {
            return get(this, 'brief.activation.status') === ACTIVATION_BRIEF_STATUS_ARCHIVED;
        },
        isBriefSubmittable() {
            return this.isBriefSubmissionActive && !this.isActivationArchived && (this.hasStatus([
                ACTIVATION_BRIEF_STATUS_NONE,
                ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL,
            ]));
        },
        isBriefEditable() {
            return !this.isActivationArchived && this.hasStatus([
                ACTIVATION_BRIEF_STATUS_NONE,
                ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL,
            ]);
        },
        isBriefNotNoneStatus() {
            return !this.hasStatus(ACTIVATION_BRIEF_STATUS_NONE);
        },
        beforeBriefStartDate() {
            // mention to include this as a dependency
            this.briefRecomputeSubmissionDatesAt;

            const startAt = moment(get(this, 'brief.activation.brief_submission_start_at')).utc();

            return startAt !== null && moment().utc().isBefore(startAt);
        },
        pastBriefEndDate() {
            // mention to include this as a dependency
            this.briefRecomputeSubmissionDatesAt;

            const endAt = moment(get(this, 'brief.activation.brief_submission_end_at')).utc();

            return endAt !== null && moment().utc().isAfter(endAt);
        },
        isBriefSubmissionActive() {
            // Submission is active for non-scheduled briefs
            if ('scheduled' !== get(this, 'brief.activation.type')) {
                return true;
            }

            return !this.beforeBriefStartDate && !this.pastBriefEndDate;
        },
    },
    methods: {
        hasStatus(status) {
            let statuses = flatten([status]);
            return statuses.includes(get(this, 'brief.status'));
        },
        briefRecomputeSubmissionDates() {
            this.briefRecomputeSubmissionDatesAt = Date.now();
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('MMM D, YYYY');
        },
        formatFullDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('MMMM D, YYYY');
        },
        formatStatus(status) {
            return ACTIVATION_BRIEF_STATUS_LABELS[status];
        }
    },
};
